import { render } from "./VisitorManagementModuleForm.vue?vue&type=template&id=9a2ccd4c"
import script from "./VisitorManagementModuleForm.vue?vue&type=script&lang=js"
export * from "./VisitorManagementModuleForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__